import React from 'react';
import Navbar from './Navbar';
import Content from './Content';
import Footer from './Footer';
import styled from 'styled-components';


const Main = styled.div`
  height:100vh;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
`;

function App() {
  return (
    <Main>
      <Navbar />
      <Content />
      <Footer />
    </Main>
  );
}

export default App;
